import { createApp, Directive } from 'vue';
import { createPinia } from 'pinia';
import router from '@/router';
import * as buffer from 'buffer';
import vConsole from 'vconsole';
// 注入全局变量
if (typeof window.global === 'undefined') {
  window.global = window;
}
if (typeof window.Buffer === 'undefined') {
  window.Buffer = buffer.Buffer;
}
//登录权限
import '@/permission';
// 国际化
import i18n from '@/lang/index';
// 样式
import '@/styles/index.less';
// 根组件
import App from '@/App.vue';
// import { setupSingleTab } from '@/utils/singleTab';

import '@arco-design/web-vue/dist/arco.css';

// 引入svg注册脚本
import 'virtual:svg-icons-register';

import 'default-passive-events';
// 自定义指令
import * as directive from '@/directive/tool';

const app = createApp(App);

// 注册所有自定义指令
Object.keys(directive).forEach(key => {
  if (key !== 'default') {
    app.directive(key, (directive as { [key: string]: Directive })[key]);
  }
});

// 创建 Pinia 实例
const pinia = createPinia();

// 使用全局插件
app.use(pinia).use(router).use(i18n).mount('#app');

// 初始化单标签页功能
// setupSingleTab();
// new vConsole();
// 禁用警告
app.config.warnHandler = () => null;
